/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
/* eslint-disable react/no-direct-mutation-state */

import { ErrorBoundaryProps } from 'carbon-components-react';
import React, { Component } from 'react';

import InternalError from '../../pages/errors/InternalError';
import { pageEvents } from '../../util/trackers/segment';

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state = { hasError: false, message: null };

  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info) {
    this.state.message = error.message;
    console.error(error, 'ErrorBoundary caught an error');

    pageEvents.internalError(null, {
      waErrorSummary: error.message,
      waErrorStack: info.componentStack
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      document.title = 'Unexpected Error';
      return <InternalError errorMessage={this.state.message} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
